import styled from "styled-components";

export const TagContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #d0d5dd;
  font-family: "Geist", sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  white-space: nowrap;
  width: fit-content;

  @media (max-width: 576px) {
    font-size: 11px;
    padding: 2px 6px;
  }

  svg {
    width: 12px;
    height: 12px;
    flex-shrink: 0;
  }
`;

export const GradientText = styled.span`
  background: linear-gradient(135deg, #e8d07a 0%, #5312d6 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
`;
